import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { HashMap, TranslocoService } from '@ngneat/transloco';

export interface NotifierParams {
  type: 'notice' | 'warn' | 'error';
  duration?: number;
}

@Injectable({
  providedIn: 'root',
})
export class NotifierService {
  constructor(
    private snackBar: MatSnackBar,
    private translocoService: TranslocoService,
  ) {}

  show(message: string, action?: string, params: NotifierParams = { type: 'notice' }): MatSnackBarRef<SimpleSnackBar> {
    const config: MatSnackBarConfig = {};

    if (params.type) {
      config.panelClass = ['crm-snack-bar', `-${params.type}`];
    }

    if (params.duration != null) {
      config.duration = params.duration;
    }

    return this.snackBar.open(message, action, config);
  }

  error(message: string, action?: string): MatSnackBarRef<SimpleSnackBar> {
    return this.show(message, action, { type: 'error', duration: 5000 });
  }

  showLocalized(key: string, params?: HashMap<unknown>): MatSnackBarRef<SimpleSnackBar> {
    return this.show(this.translocoService.translate(key, params));
  }

  errorLocalized(key: string, params?: HashMap<unknown>): MatSnackBarRef<SimpleSnackBar> {
    return this.error(this.translocoService.translate(key, params));
  }

  openFromComponent<T>(component, data: T): MatSnackBarRef<SimpleSnackBar> {
    return this.snackBar.openFromComponent(component, data);
  }
}
